import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'
import { parseCardsForFeature } from '@/assets/scripts/parsers/cards'

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns Cards list
@return { Array }
*/
export const getCards = state => {
    return parseCardsForFeature(state.cardsList).map(card => {
        return {
            ...card,
            cardBalance: card.balance,
            cardCurrency: card.currency,
            productName: card.product,
            cardDescription: (card.additionalInfoCardView && card.additionalInfoCardView.friendlyName) ? card.additionalInfoCardView.friendlyName : null
        }
    })
}

export const getAvailablePlafond = state => state.availablePlafond

export const getExchange = state => state.exchange

/** returns Last Charges List
@return { Array }
*/
export const getLastChargesList = state => state.lastChargesList

/** returns Favorites List
@return { Array }
*/
export const getFavoritesList = state => state.favoritesList

/** returns Favorites hasMore value
@return { Boolean }
*/
export const getFavoritesHasMore = state => state.favoritesHasMore